/**
 * api.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

// API utility with automatic token expiration handling

let logoutCallback = null;

export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

// Wrapper around fetch that handles 401 errors
export const authenticatedFetch = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);
    
    // Check for 401 Unauthorized (token expired or invalid)
    if (response.status === 401) {
      console.warn('Received 401 Unauthorized - token may be expired');
      
      // Check if the error is specifically about token expiration
      try {
        const errorData = await response.clone().json();
        
        // Check for token expiration or invalid token errors
        if (errorData.error === 'Token expired.' || 
            errorData.error === 'Invalid token.' || 
            errorData.error === 'Access denied. No token provided.') {
          console.log('Token expired or invalid, triggering auto-logout');
          
          // Call the logout callback if available
          if (logoutCallback) {
            logoutCallback();
          }
        }
      } catch (e) {
        // If we can't parse the error, still trigger logout on 401
        console.log('Unable to parse error response, triggering logout on 401');
        if (logoutCallback) {
          logoutCallback();
        }
      }
    }
    
    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

// Helper to get the current token
export const getToken = () => {
  return localStorage.getItem('token');
};

// Helper to get auth headers
export const getAuthHeaders = () => {
  const token = getToken();
  return token ? {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  } : {
    'Content-Type': 'application/json'
  };
};

